module.exports = __webpack_public_path__ + "static/img/c_2.d78f688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashu/c_2.png
// module id = v4hd
// module chunks = 1